import ReviewsProductInfoEntity from "@apps/reviews/widgets/average_reviews_widget/entities/ReviewsProductInfoEntity";
import ReviewsProductInfoSchema from "@apps/reviews/widgets/average_reviews_widget/schemas/ReviewsProductInfoSchema";
import ReviewsProductInfoStore from "@apps/reviews/widgets/average_reviews_widget/stores/ReviewsProductInfoStore";
import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import { create } from "superstruct";
import { injectable } from "tsyringe";

import { LoggerInterface } from "@interfaces/LoggerInterface";

type GetReviewsProductInfoParams = {
    productId: number;
};

@injectable()
class ReviewsProductInfoService {
    constructor(
        private readonly reviewsProductInfoStore: ReviewsProductInfoStore,
        private readonly authApiClient: ApiClientInterface,
        private readonly logger: LoggerInterface
    ) {}

    getReviewsProductInfo(
        params: GetReviewsProductInfoParams
    ): Observable<ReviewsProductInfoEntity> {
        this.logger.debug("ReviewsService.getProductInfo is started", params);
        return this.authApiClient
            .get({
                url: "/review/getProductReviewInfo",
                responseType: "json",
                queryParams: {
                    ...params,
                },
            })
            .pipe(
                map((v) => create(v.body, ReviewsProductInfoSchema)),
                catchError((error: unknown) => {
                    this.logger.debug(
                        "ReviewsService.getProductInfo is errored",
                        params
                    );
                    throw error;
                }),
                tap((v) => {
                    this.logger.debug(
                        "ReviewsService.getProductInfo is ready",
                        params
                    );
                    this.reviewsProductInfoStore.update((state) => ({
                        ...state,
                        productInfo: v,
                    }));
                })
            );
    }
}

export default ReviewsProductInfoService;
